'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var _babelHelpers = require('./_babelHelpers-48e7a7f7.js');
var settings = require('./settings-9ee2f03f.js');

var _templateObject = _babelHelpers.taggedTemplateLiteral(["\n  color: white;\n  display: inline-block;\n  font-size: 12px;\n  margin-left: 5px;\n  text-align: center;\n  border-radius: 1em;\n  font-weight: 600;\n  max-width: 25px;\n  padding: 0px 5px;\n  height: 16px;\n  box-sizing: border-box;\n  line-height: 16px;\n  background-color: ", ";\n  font-family: ", ";\n  ", "\n"], ["\n  color: white;\n  display: inline-block;\n  font-size: 12px;\n  margin-left: 5px;\n  text-align: center;\n  border-radius: 1em;\n  font-weight: 600;\n  max-width: 25px;\n  padding: 0px 5px;\n  height: 16px;\n  box-sizing: border-box;\n  line-height: 16px;\n  background-color: ", ";\n  font-family: ", ";\n  ", "\n"]);

var Badge = styled__default.div(_templateObject, function (props) {
  return props.background ? props.background : settings.COLOR.softRed;
}, function (props) {
  return props.fontFamily ? props.fontFamily : "Source Sans Pro, sans-serif";
}, function (props) {
  return "\n    " + (props.styles ? props.styles : "") + "\n  ";
});

exports.Badge = Badge;
exports.default = Badge;
//# sourceMappingURL=badge.js.map
